"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pusher_js_1 = __importDefault(require("pusher-js"));
var PusherService = /** @class */ (function () {
    function PusherService() {
        var _a, _b, _c, _d, _e;
        this.channels = {};
        if (process.env.MIX_PUSHER_APP_CLUSTER) {
            this.pusher = new pusher_js_1.default((_a = process.env.MIX_PUSHER_APP_KEY) !== null && _a !== void 0 ? _a : "", {
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                forceTLS: true,
            });
        }
        else {
            this.pusher = new pusher_js_1.default((_b = process.env.MIX_PUSHER_APP_KEY) !== null && _b !== void 0 ? _b : "", {
                wsHost: (_c = process.env.MIX_PUSHER_HOST) !== null && _c !== void 0 ? _c : "",
                wsPort: parseInt((_d = process.env.MIX_PUSHER_PORT) !== null && _d !== void 0 ? _d : "", 10),
                forceTLS: ((_e = process.env.MIX_PUSHER_SCHEME) !== null && _e !== void 0 ? _e : "") === "wss",
                enabledTransports: ["ws"],
                disabledTransports: ["wss"],
            });
        }
    }
    PusherService.prototype.bind = function (channel, event, handler) {
        if (!this.channels[channel]) {
            this.channels[channel] = this.pusher.subscribe(channel);
        }
        this.channels[channel].bind(event, handler);
    };
    return PusherService;
}());
var pusherService = new PusherService();
exports.default = pusherService;
